module.exports = __webpack_public_path__ + "img/goods_06.9f386b5b.jpg";